import React, { useState } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Link } from "react-router-dom";
import faqBanner from "../../Images/student-services/ragging.webp";
import classroomImage from "../../Images/gov-body/rules.webp";
import { Row } from "react-bootstrap";

const body = [
    {
        name: "Dr. N. Kumar Swamy",
        remarks: "Chairperson"
    },
    {
        name: "Dr. Sandeep Kumar",
        remarks: "Member"
    },
    {
        name: "Mr. Rajendra Prasad Gendre",
        remarks: "Member"
    },
    {
        name: "Dr. Garima Diwan",
        remarks: "Member"
    },
    {
        name: "Dr. Poonam Verma",
        remarks: "Member"
    },
    {
        name: "Smt. Kesharlata Sahu",
        remarks: "Member"
    },
    {
        name: "Ms. Rekha Sahu",
        remarks: "Member"
    },
    {
        name: "Ms. Lalita Sahu",
        remarks: "Member"
    },
    {
        name: "Mr. Pukhraj Yadaw",
        remarks: "Member"
    },
];

const AntiRagging = () => {
    return (
        <>
            <title>ISBM University Anti-Ragging Squad | Zero Tolerance for Ragging</title>
            <meta
                name="description"
                content="The Anti-Ragging Squad at ISBM University works tirelessly to promote student safety by preventing ragging & maintaining a harmonious campus atmosphere."
            />
            <Topnav />
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${faqBanner})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="container-xxl">
                        <div className="section-hero-content">
                            <h1>Anti-Ragging Squad</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <Link to="/" style={{ color: "#fff", textDecoration: "none" }}>
                                        Home
                                    </Link>
                                </li>
                                <li className="breadcrumb-item active text-white" aria-current="page">
                                    Anti-Ragging Squad
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-xxl ptb-50">
                    <Row className="m-0">
                        <div className="col-md-6">
                            <div className="governing-image-wrapper shadow">
                                <img src={classroomImage} alt="Governing Body" />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <h2 className="modern-title text-blue">Anti-Ragging Squad</h2>
                            <div className="underline-divider mb-3"></div>
                            <p className="text-muted">
                                The Anti-Ragging Squad at ISBM University plays a crucial role in maintaining
                                discipline and ensuring a ragging-free campus. The squad functions as a vigilant,
                                mobile, and proactive body that conducts surprise inspections in hostels, classrooms,
                                and common areas to prevent any form of ragging or misconduct. It operates
                                independently but works closely with the Anti-Ragging Committee for prompt action
                                and reporting.
                            </p>
                            <p className="text-muted">
                                Comprising faculty members and administrative staff, the squad acts immediately
                                on any suspicion or complaint related to ragging. Their presence not only helps
                                deter such activities but also reassures students of a safe and supportive
                                academic environment. ISBM University encourages all students to cooperate with the
                                squad and uphold the university’s values of respect, safety, and inclusivity.
                            </p>
                        </div>
                    </Row>
                </div>
            </section>

            <section className="visa-section py-5 bg-light">
                <div className="container-xxl">
                    <h2 className="text-center modern-title text-blue">Anti-Ragging Squad</h2>
                    <div className="underline-center mb-5 mx-auto"></div>
                    <div className="row m-0">
                        {body.map((member, index) => (
                            <div className="col-lg-4 col-md-6 d-flex mb-3" key={index}>
                                <div className="visa-box p-4 shadow w-100 h-100 d-flex flex-column">
                                    <div className="visahead">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <h5 className="text-dark mb-0">{member.name}</h5>
                                            <span className="badge designation ms-2 ">
                                                {member.designation}
                                            </span>
                                        </div>
                                        <div className="underlinetwo"></div>
                                    </div>
                                    <ul className="mb-0 list-unstyled">
                                        <li>{member.remarks}</li>
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default AntiRagging;
